module.exports = __webpack_public_path__ + "static/media/trimex_seisaspas_extrafina.e4253428.png";